import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=00fe4747&scoped=true"
import script from "./addClass.vue?vue&type=script&lang=js"
export * from "./addClass.vue?vue&type=script&lang=js"
import style0 from "./addClass.vue?vue&type=style&index=0&id=00fe4747&prod&lang=scss&scoped=true"
import style1 from "./addClass.vue?vue&type=style&index=1&id=00fe4747&prod&lang=scss&scoped=true"
import style2 from "./addClass.vue?vue&type=style&index=2&id=00fe4747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe4747",
  null
  
)

export default component.exports